import React from 'react'
import FormRoom from '../components/FormRoom'
import hipladeTemplate from '../../common/template'

function RoomsForm() {
  return <FormRoom />
}

export default hipladeTemplate(RoomsForm)
